import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bff0355a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "open-positions-item-mobile" }
const _hoisted_2 = { class: "open-positions-item-mobile__header" }
const _hoisted_3 = { class: "open-positions-item-mobile__market-info" }
const _hoisted_4 = { class: "open-positions-item-mobile__market-name" }
const _hoisted_5 = { class: "open-positions-item-mobile__details" }
const _hoisted_6 = { class: "open-positions-item-mobile__column" }
const _hoisted_7 = { class: "open-positions-item-mobile__row" }
const _hoisted_8 = { class: "open-positions-item-mobile__label" }
const _hoisted_9 = { class: "open-positions-item-mobile__row" }
const _hoisted_10 = { class: "open-positions-item-mobile__label" }
const _hoisted_11 = { class: "open-positions-item-mobile__value" }
const _hoisted_12 = { class: "open-positions-item-mobile__row" }
const _hoisted_13 = { class: "open-positions-item-mobile__label" }
const _hoisted_14 = { class: "open-positions-item-mobile__value" }
const _hoisted_15 = { class: "open-positions-item-mobile__row" }
const _hoisted_16 = { class: "open-positions-item-mobile__label" }
const _hoisted_17 = { class: "open-positions-item-mobile__value" }
const _hoisted_18 = { class: "open-positions-item-mobile__column" }
const _hoisted_19 = { class: "open-positions-item-mobile__row" }
const _hoisted_20 = { class: "open-positions-item-mobile__label" }
const _hoisted_21 = { class: "open-positions-item-mobile__value" }
const _hoisted_22 = { class: "open-positions-item-mobile__row" }
const _hoisted_23 = { class: "open-positions-item-mobile__label" }
const _hoisted_24 = { class: "open-positions-item-mobile__row" }
const _hoisted_25 = { class: "open-positions-item-mobile__label" }
const _hoisted_26 = { class: "open-positions-item-mobile__value" }

import { OtIcon, OtLozenge, OtNumberDisplay } from '@1trading/design-system';
import { computed, type PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import type { NormalizedPerpsPosition } from '@exchange/libs/account/service/src/lib/wss-account-messages';

import usePositionComputed from '../../usePositionComputed';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositionsItemMobile',
  props: {
  position: { type: Object as PropType<NormalizedPerpsPosition>, required: true },
  maxLeverage: { type: Number, required: false },
  isCurrentMarketPosition: { type: Boolean, required: true },
},
  emits: ['close-position'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n({ useScope: 'global' });

const props = __props;

const emit = __emit;

const { position, maxLeverage } = toRefs(props);
const { marginUsed, market } = usePositionComputed(position, maxLeverage);

const directionText = computed(() => (props.position.direction === 'LONG' ? t('fundamentals.orders.side.long') : t('fundamentals.orders.side.short')));

const handleClosePosition = () => {
  emit('close-position', props.position);
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(market)?.name), 1),
        _createVNode(_unref(OtLozenge), {
          filled: false,
          text: _ctx.$t('fundamentals.perpetual.short'),
          class: "open-positions-item-mobile__lozenge"
        }, null, 8, ["text"])
      ]),
      _createVNode(_component_x_button, {
        class: "open-positions-item-mobile__close-button",
        size: "3xs",
        variant: "tertiary",
        onClick: handleClosePosition
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(OtIcon), { name: "close-square" })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('modules.myOrders.header.side')) + ":", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["open-positions-item-mobile__value", { buy: _unref(position).direction === 'LONG', sell: _unref(position).direction === 'SHORT' }])
          }, _toDisplayString(directionText.value), 3)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('modules.myOrders.header.size')) + ":", 1),
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_unref(OtNumberDisplay), {
              number: _unref(position).open_volume,
              precision: _unref(market)?.marketPrecision,
              suffix: _unref(market)?.base.code
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('modules.myOrders.header.averageEntryPrice')) + ":", 1),
          _createElementVNode("span", _hoisted_14, [
            _createVNode(_unref(OtNumberDisplay), {
              number: _unref(position).average_entry_price,
              precision: _unref(market)?.marketPrecision,
              suffix: _unref(market)?.quote.code
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('modules.myOrders.header.positionValue')) + ":", 1),
          _createElementVNode("span", _hoisted_17, [
            _createVNode(_unref(OtNumberDisplay), {
              number: _unref(position).open_position,
              precision: _unref(market)?.marketPrecision,
              suffix: _unref(market)?.quote.code
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('modules.myOrders.header.markPrice')) + ":", 1),
          _createElementVNode("span", _hoisted_21, [
            _createVNode(_unref(OtNumberDisplay), {
              number: _unref(position).mark_price,
              precision: _unref(market)?.marketPrecision,
              suffix: _unref(market)?.quote.code
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('modules.myOrders.header.realisedPnl')) + ":", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["open-positions-item-mobile__value", { positive: Number(_unref(position).realised_pnl) > 0, negative: Number(_unref(position).realised_pnl) < 0 }])
          }, [
            _createVNode(_unref(OtNumberDisplay), {
              number: Number(_unref(position).realised_pnl),
              precision: _unref(market)?.marketPrecision,
              suffix: _unref(market)?.quote.code
            }, null, 8, ["number", "precision", "suffix"])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('modules.myOrders.header.marginUsed')) + ":", 1),
          _createElementVNode("span", _hoisted_26, [
            _createVNode(_unref(OtNumberDisplay), {
              number: _unref(marginUsed),
              precision: _unref(market)?.marketPrecision,
              suffix: _unref(market)?.quote.code
            }, null, 8, ["number", "precision", "suffix"])
          ])
        ])
      ])
    ])
  ]))
}
}

})